import { defaultConfig } from '@/configByPartner/default.config';

export const BASE_PATH = `${defaultConfig.server?.apiServer}/v1`;
